import { Button } from "../../utils/Utils";
import { GameVars } from "../../GameVars";
import { AudioManager } from "../../AudioManager";
import { BoardManager } from "./BoardManager";
declare var gamezop : any;
export class GUI extends Phaser.GameObjects.Container {
    private audioOnButton : Button
    private audioOffButton : Button
    constructor(scene: Phaser.Scene) {
        
        super(scene);

        if (gamezop.isBattleGame()) {
            this.audioOnButton = new Button(this.scene, 90, 95 * GameVars.scaleY, "texture_atlas_4", "btn_sound_on_off", "btn_sound_on_on");
            this.audioOnButton.onDown(this.onClickAudioButton, this);
            this.audioOnButton.scaleY = GameVars.scaleY;
    
            this.audioOffButton = new Button(this.scene, 90, 95 * GameVars.scaleY, "texture_atlas_3", "btn_sound_off_off", "btn_sound_off_on");
            this.audioOffButton.onDown(this.onClickAudioButton, this);
            this.audioOffButton.scaleY = GameVars.scaleY;
    
            this.add([this.audioOffButton, this.audioOnButton]);
        } else {
            const menuButton = new Button(this.scene, 90, 95 * GameVars.scaleY, "texture_atlas_6", "btn_menu_off", "btn_menu_on");
            menuButton.onDown(this.onClickMenu, this);
            menuButton.scaleY = GameVars.scaleY;
            this.add(menuButton);
        }

    }

    private onClickMenu(): void {

        if (GameVars.paused) {
            return;
        }
        
        BoardManager.currentInstance.pause();

        AudioManager.playSound("btn_click");
    }

    private onClickAudioButton(): void {

        AudioManager.toggleAudioState();

        if (GameVars.gameData.muted) {
            this.audioOnButton.visible = false;
            this.audioOffButton.visible = true;
        } else {
            this.audioOnButton.visible = true;
            this.audioOffButton.visible = false;
        }

        AudioManager.playSound("btn_click");
    }
}
